// extracted by mini-css-extract-plugin
export default {"report-categories-item-section":"ReportCategoriesItemSection_report-categories-item-section__TU2Lb","categories-wrapper":"ReportCategoriesItemSection_categories-wrapper__yMi5x"};